/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import moment from 'moment';
import React, { useCallback, useMemo, useState } from 'react';
import './Nocsidebar.css';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import SolidGauge from 'highcharts/modules/solid-gauge';
import { fetchNewDashboardHeaderData, fetchNewDashboardRealTimeGunInfo, fetchNewDashboardConnectivityMediumData, getDashboardReducer, fetchChargerProductTypeReferenceData, getReferenceDataReducer, fetchAlarmSeverityReferenceData, fetchNewDashboardFailedTransactionList, fetchNewDashboardFailedTransactionTopReasons, fetchIntervalRangeRefData, fetchNewDashboardAIInsightsList, fetchNewDashboardChargingSessionsList, fetchNewDashboardChargingSessionTrendList, fetchNewDashboardChargingVsIdleList, getAlarmReducer, fetchAlarmCardCountData, fetchNewDashboardAlarmSummaryList, fetchNewDashboardEnergyTrendList, fetchNewDashboardOverallUptimeList, fetchNewDashboardAttentionRequiredList, fetchNewDashboardEfficiencyTrendList, fetchNewDashboardReactiveEnergyConsumptionTrendList, setChargerIdsForRedirection } from '../../rmsReduxStore/reduxExports';
import { useAppDispatch, useAppSelector, useEffectOnce } from '../../globalUtils/globalExports';
import { useNavigate } from 'react-router-dom';
import { formatRelativeTimeForTable } from '../../globalUtils/globalHooks';
import {
  getChargerReducer,
  getCurrentFiltersValues, getFilterSelectedValue, setFilterData
} from '../../rmsReduxStore/reduxExports';
import {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  FilledChargerCards,


} from '../../globalUtils/globalExports';
import { NocFilledChargerCards } from './NocFilledChargerCards';
import { Icon, IconWithTooltip } from '../../globalUtils/globalIcons';
import { CustomTooltipWithLabel } from '../../globalUtils/globalExports';

HighchartsMore(Highcharts);
SolidGauge(Highcharts);


export interface ChargerDataProps {
  chargerDetails?: ILatestChargerDetails;
  alarmDetails?: ILatestChargerAlarmDetails;
}


const NocStatusCards: React.FC<ChargerDataProps> = ({ chargerDetails, alarmDetails }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [customerFilterValue, setCustomerFilterValue] = useState<IGeneralReferenceData>();
  const [productFilterValue, setProductFilterValue] = useState<IGeneralReferenceData>();


  useEffectOnce(() => {
    dispatch(fetchChargerProductTypeReferenceData());
    dispatch(fetchAlarmSeverityReferenceData());
    dispatch(fetchIntervalRangeRefData());
    const customerFilter = getFilterSelectedValue('customer', 'global', true);
    setCustomerFilterValue(customerFilter);
    const productFilter = getFilterSelectedValue('productType', 'dashboardV2', false);
    setProductFilterValue(productFilter);
  })
  const chargerHeaderCards = useMemo(() => {
    const lastPingTime = chargerDetails?.lastPingAt;
    const statusBackgroundColor = chargerDetails?.chargerStatus ? chargerDetails?.chargerStatus === 'Online' ? 'var(--card-green-color)' : (chargerDetails?.chargerStatus === 'Offline' || chargerDetails?.chargerStatus === 'RMS Disable') ? 'var(--grey-color)' : 'var(--grey-color))' : 'var(--grey-color))';
    const alarmBackgroundColor = (!chargerDetails?.alarmStatus || chargerDetails?.alarmStatus === 'No alarm') ? 'var(--green-color)' : chargerDetails.alarmStatus === 'Critical' ? 'var(--critical-alarm-color)' : chargerDetails?.alarmStatus === 'Major' ? 'var(--major-alarm-color)' : 'var(--minor-alarm-color)';
    const LastPingBackgroundColor = lastPingTime ? Math.floor(((Math.abs(new Date(lastPingTime).valueOf() - new Date().valueOf())) / 1000) / 60) > 10 ? 'var(--card-grey-color)' : 'var(--charger-card-purple-color)' : 'var(--charger-card-purple-color)';

    return [
      {
        cardId: 'status',
        headerText: 'status',
        footerText: chargerDetails?.chargerStatus ? chargerDetails?.chargerStatus : 'Offline',
        bgColor: statusBackgroundColor
      },
      {
        cardId: 'last-ping',
        headerText: 'lastPing',
        footerText: lastPingTime && moment(lastPingTime).format('MMM Do') ? moment(lastPingTime).format('MMM Do') : 'Apr 25th',
        footerSubText: lastPingTime?.split('T')?.[1].split('.')?.[0],
        bgColor: LastPingBackgroundColor
      },
      // {
      //   cardId: 'alarm-status',
      //   headerText: 'alarmStatus',
      //   footerText: chargerDetails?.alarmStatus ? chargerDetails?.alarmStatus : 'Critical',
      //   bgColor: alarmBackgroundColor
      // }
    ]
  }, [chargerDetails])



  if (!chargerDetails || Object.keys(chargerDetails).length === 0) {
    return (
      <div className="noc-statuscard-container no-data">
        <div className="noc-statuscard no-data-card">
          <Icon iconClassName='mobile__view__charger__icon' />
          <span className="nocstatuscard-charger-status-label">No charger available</span>
        </div>
      </div>
    );
  }

  const handleChargerNavigation = (chargerId: string, chargerVisibleId: string) => {
    dispatch(setChargerIdsForRedirection([chargerId]))
    window.open(`/charger?chargerId=${chargerVisibleId}&redirectedFrom=nocDashboard`, '_blank');
  }
  return (
    <div className='noc-statuscard-main-container'>
      <div className="noc-statuscard-container">
        <div className='noc-statuscard'>
          <div className='noc-statuscard-row'>
            <div className='noc-statuscard-charger-detail-row' onClick={() => { handleChargerNavigation(chargerDetails?.chargerId ?? '', chargerDetails?.chargerName) }}>

              <Icon iconClassName='noc-dashboard-right-panel-charger-icon' />

              <span className='noc-statuscard-chargername'>
                <CustomTooltipWithLabel label={chargerDetails?.chargerName} labelId='charging__station-notes' />
                {/* {chargerDetails?.chargerName} */}
              </span>
            </div>
            <div className='noc-statuscard-occupid'>
              <span className='nocstatuscard-occp-label'>OCPP ID:</span>
              {/* <span className='nocstatuscard-value'>
        <CustomTooltipWithLabel label={chargerDetails?.ocppId}  labelId='charging__station-notes'/>
      </span> */}
              <span className='nocstatuscard-value'>
                <CustomTooltipWithLabel label={chargerDetails?.ocppId} labelId='charging__station-notes' />
                {/* {chargerDetails?.ocppId} */}

              </span>
            </div>
          </div>

          <div className='noc-statuscard-row'>
            <div className='noc-location-wrapper'>
              <span className='nocstatuscard-label-chargingstation'>
                <CustomTooltipWithLabel label={chargerDetails?.chargingStationName || 'Charging Station : NA'} labelId='charging__station-notes' />
                {/* {chargerDetails?.address || 'Charging Station : NA'} */}
              </span>

              <div className='noc-user-wrapper'>
                |  <Icon iconClassName='noc-dashboard-right-panel-user-icon' />
                <span className='nocstatuscard-label'>
                  <CustomTooltipWithLabel label={chargerDetails?.customer} labelId='charging__station-notes' />
                  {/* {chargerDetails?.customer} */}
                </span>
              </div>
            </div>

          </div>

          <div className='noc-product-badges'>
            <div className='noc-product-badge'>
              <div className='badge badge-product'>{chargerDetails?.product}</div>
              {chargerDetails?.rmsStatus === 'Enable' ? (
                <div className='badge badge-green'>RMS
                  <IconWithTooltip iconClassName='noc-dashboard-right-panel-charger-connectivity-enable-icon' toolTipText={'RMS Enabled'} />
                </div>
              ) : (
                <div className='badge badge-red'>RMS
                  <IconWithTooltip iconClassName='noc-dashboard-right-panel-charger-connectivity-disable-icon' toolTipText={'RMS Disabled'} /></div>
              )}
              {chargerDetails?.cmsConnectivity === 'OK' ? (
                <div className='badge badge-green'>CMS
                  <IconWithTooltip iconClassName='noc-dashboard-right-panel-charger-connectivity-enable-icon' toolTipText={'CMS Enabled'} />
                </div>
              ) : (
                <div className='badge badge-red'>CMS
                  <IconWithTooltip iconClassName='noc-dashboard-right-panel-charger-connectivity-disable-icon' toolTipText={'CMS Disabled'} />
                </div>
              )}
            </div>
            <div className='noc-charger-connection-status'>
              {chargerDetails?.connector1Charging !== null && (
                <div className='noc-cable'>
                  C1
                  {chargerDetails?.connector1Charging === 1 ? (
                    <IconWithTooltip

                      iconClassName='noc-dashboard-legend-active-charging-session'
                      toolTipText={'Active Charging Session'}
                    />
                  ) : (
                    <IconWithTooltip

                      iconClassName='rms__icon custom__noc__map__charging-status-inactive-btn-icon'
                      toolTipText={'Idle Charger'}
                    />
                  )}
                </div>
              )}

              {chargerDetails?.connector2Charging !== null && (
                <div className='noc-cable'>
                  C2
                  {chargerDetails?.connector2Charging === 1 ? (
                    <IconWithTooltip

                      iconClassName='noc-dashboard-legend-active-charging-session'
                      toolTipText={'Active Charging Session'}
                    />
                  ) : (
                    <IconWithTooltip
                      iconClassName='rms__icon custom__noc__map__charging-status-inactive-btn-icon'
                      toolTipText={'Idle Charger'}
                    />
                  )}
                </div>
              )}
              {chargerDetails?.connector3Charging !== null && (
                <div className='noc-cable'>
                  C3
                  {chargerDetails?.connector3Charging === 1 ? (
                    <IconWithTooltip

                      iconClassName='noc-dashboard-legend-active-charging-session'
                      toolTipText={'Active Charging Session'}
                    />
                  ) : (
                    <IconWithTooltip

                      iconClassName='rms__icon custom__noc__map__charging-status-inactive-btn-icon'
                      toolTipText={'Idle Charger'}
                    />
                  )}
                </div>
              )}
            </div>
          </div>


        </div>

      </div>
      <div className="nocstatuscard_charger__panel-alarm-cards">
        {chargerHeaderCards?.map((card, i) => (
          <NocFilledChargerCards
            key={'charger-card-' + i}
            cardId={card.cardId}
            headerText={card.headerText}
            footerText={card.footerText}
            footerSubText={card.footerSubText}
            bgColor={card.bgColor}
          />
        ))}

        {/* <NocFilledChargerCards
      key={'charger-card-latest'}
      cardId='latest-alarm'
      headerText='latestAlarm'
      footerText='Emergency Pressed'
      bgColor='rgba(252, 176, 170, 1)'
    /> */}
      </div>
    </div>
  );
};

export default NocStatusCards;